import { render, staticRenderFns } from "./passengerAddOrUpdate.vue?vue&type=template&id=2e903f88&scoped=true"
import script from "./passengerAddOrUpdate.vue?vue&type=script&lang=js"
export * from "./passengerAddOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./passengerAddOrUpdate.vue?vue&type=style&index=0&id=2e903f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e903f88",
  null
  
)

export default component.exports